const localeLanguages = {
  en: 'en-US',
  ar: 'ar-EG',
  id: 'id-ID',
};

const getLocaleDate = ({ date, language = 'en' }) => {
  const dateObj = new Date(date);
  const event = new Date(
    Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()),
  );
  const dateLocale = event.toLocaleDateString(localeLanguages[language], {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return dateLocale;
};

export default getLocaleDate;
